import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { DBDef_DiseaseValue } from './db-def.js';
export const ApiDef_DiseaseValue = {
    _v1: {
        convertToExpression: { method: HttpMethod.GET, path: `/v1/${DBDef_DiseaseValue.dbKey}/convert-to-exp` },
    }
};
//# sourceMappingURL=api-def.js.map